import { render, staticRenderFns } from "./outerPaymentForm.vue?vue&type=template&id=071d630b&scoped=true"
import script from "./outerPaymentForm.vue?vue&type=script&lang=js"
export * from "./outerPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d630b",
  null
  
)

export default component.exports